import { EmptyStateProps } from "@nef/core/lib/components/EmptyState"

import { DeleteModalProps, EnumWithDescription } from "../types/common"

const ADD_AFFILIATES_LINK = "../new_affiliates/"

// format "page-module-search"
export const SEARCH_PAGE_CONFIG: any = {
  "orgManager-Main-OrgSearch": {},
  "orgManager-AccessControl-IssuerSearch": { active: true },
  "issuerManager-Main-issuerSearch": {},
  "issuerManager-AccessControl-OrgSearch": { active: true }
}

export const TABLE_EMPTY_STATE: EmptyStateProps = {
  icon: "documents",
  emptyStateTitle: "No data available"
}

export const TABLE_EMPTY_STATE_MESSAGE = {
  title: "No data available",
  subtitle: "Please select the appropriate filters"
}

export const TABLE_EMPTY_API_DATA = {
  title: "No data available",
  subtitle: ""
}

export const NULLABLE_BOOLEAN_DROPDOWN : EnumWithDescription[] = [
  {
    value: true,
    description: "Yes"
  },
  {
    value: false,
    description: "No"
  },
  {
    value: null,
    description: "Not Assigned"
  }
]

export const TABLE_FILTER_BOOLEAN_FDROPDOWN = [
  {
    label: "Yes",
    value: true
  },
  {
    label: "No",
    value: false
  }
]

export const DELETE_MODAL_PROPS: DeleteModalProps = {
  isOpen: false,
  info: "",
  onConfirm: () => { },
  toggle: () => { },
  isLoading: false
}

export const LEVERAGE_DROPDOWN = [
  {
    value: 1,
    description: 1
  },
  {
    value: 1.25,
    description: 1.25
  },
  {
    value: 1.5,
    description: 1.5
  },
  {
    value: 2,
    description: 2
  },
  {
    value: 3,
    description: 3
  },
  {
    value: 4,
    description: 4
  },
  {
    value: "NA",
    description: "Not Assigned"
  }
]

export const SRRI_DROPDOWN = [...Array(7)].map((_: number, index: number) => ({
  value: index + 1,
  description: index + 1
}))

export const DISPLAY_DATE_FORMAT = "MM/DD/YYYY"
export const DISPLAY_DATE_TIME_FORMAT = "MM/DD/YYYY HH:mm:ss"
export const DISPLAY_DATE_TIME_FORMAT_12HR = "MM/DD/YYYY hh:mm:ss"
export const DISPLAY_TIME_FORMAT = "HH:mm:ss"
export const API_TIME_FORMAT = "HHmmss"
export const API_DATE_FORMAT = "YYYY-MM-DD"
export const SERVER_DATE_TIME_FORMAT = "MM/DD/YYYY h:mm A, [ET]"
export const SERVER_TZ = "America/New_York"

export const HEADERS = {
  txt: { Accept: "text/pipe" },
  csv: { Accept: "text/csv" },
  json: { Accept: "application/json" }
}

export const NFN_OPS_EMAIL_HREF = "mailto:NFNOps@nasdaq.com"
export const NFN_OPS_EMAIL = "NFNOps@nasdaq.com"
export const NFN_OPS_TEL = "+1 301 978 5307 (Option 6)"
export const NFN_OPS_TEL_HREF = "tel:+13019785307"
export const NFN_MFA_HREF = "https://security.nasdaq.com"
export const NFN_LEGACY_HREF = process.env.REACT_APP_ACCESS_TYPE?.trim() === "external" ? "https://nfn.nasdaq.com/" : "https://nfn-admin.nasdaq.com/"
export const TEST_ISSUER_ID = 1287


export const AcceptedFileOptions = {
  csv: ["text/csv"],
  excel: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"],
  pdf: ["application/pdf"]
}

// m/d/yy; mm/dd/yyyy; mm/d/yy; mm/dd/yy; Month Day, YYYY
// these date formats will be supported onBlur on the date picker
// if user copy pastes below formats to datepicker, it will auto format it to MM/DD/YYYY (display date format)
export const VALID_DATE_FORMATS = ['M/D/YY', 'MM/DD/YYYY', 'MM/D/YY', 'MM/DD/YY', 'MMMM Do, YYYY']

export default ADD_AFFILIATES_LINK
